import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import LayoutDetails from 'components/ModalWindows/LayoutDetails';
import { LayoutDetailsActions, LayoutDetailsOwnProps, LayoutDetailsSelectors } from 'components/ModalWindows/LayoutDetails/models';
import { documentTypes } from 'containers/DocumentTypes/selectors';
import { hideModal } from 'containers/ModalManager/actions';
import { modalWindowOptions } from 'containers/ModalManager/selectors';
import { updateReusableLayoutTags } from './actions';

const mapStateToProps = (_, props: LayoutDetailsOwnProps) => createStructuredSelector({
  options: modalWindowOptions(props.modalWindowId),
  documentTypes,
});

const mapDispatchToProps = {
  hideModal,
  updateReusableLayoutTags,
};

export default connect<LayoutDetailsSelectors, LayoutDetailsActions, LayoutDetailsOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(LayoutDetails);
